import {AccessArea} from 'Common/permissions/AccessArea';
import {Role} from 'Common/permissions/Role';
import {BrowserOrServerId} from 'Browser/BrowserId';

export class PublicRole<Id extends BrowserOrServerId> extends Role<Id>
{
	constructor()
	{
		super('public');
	}

	public toJson()
	{
		return {
			type: this.name
		};
	}

	public topAccess(): AccessArea
	{
		return new AccessArea('unrestricted');
	}

	public canAccessArea(area:AccessArea)
	{
		return (new AccessArea('unrestricted')).includes(area);
	}
}

